






































































































































import { Component, Vue } from 'vue-property-decorator'
import VueDragDrop from 'vue-drag-drop'
import { polyfill } from 'mobile-drag-drop'
import ChickenCharacter from '@/components/ChickenCharacter.vue'

Vue.use(VueDragDrop)
polyfill()

@Component({
  components: { ChickenCharacter }
})
export default class ChickenStable extends Vue {
  normalOver = false
  organicOver = false
  normalChickens = 0
  organicChickens = 0

  addChicken(type = 'organic') {
    if (type === 'organic') {
      this.organicChickens =
        this.organicChickens < 99 ? this.organicChickens + 1 : 99
    } else
      this.normalChickens =
        this.normalChickens < 100 ? this.normalChickens + 1 : 99
  }

  removeChicken(type = 'organic') {
    if (type === 'organic') {
      this.organicChickens =
        this.organicChickens >= 0 ? this.organicChickens - 1 : 0
    } else
      this.normalChickens =
        this.normalChickens >= 0 ? this.normalChickens - 1 : 0
  }

  resetChicken() {
    this.normalChickens = 0
    this.organicChickens = 0
  }

  handleNormalDrop() {
    this.normalOver = false
    this.addChicken('normal')
  }

  handleOrganicDrop() {
    this.organicOver = false
    this.addChicken('organic')
  }

  handleEnter(data: object, event: any) {
    event.preventDefault()
  }

  checkResults() {
    this.$emit('get-numbers', this.normalChickens, this.organicChickens)
    this.$emit('show-results')
  }

  get isMobile() {
    return window.innerWidth < 1000
  }

  get isTablet() {
    return window.innerWidth < 1650 && window.innerWidth >= 1000
  }

  get dragLeft() {
    return this.isTablet ? 5 : this.isMobile ? 5 : 5
  }

  get dragTop() {
    return this.isTablet ? 3 : this.isMobile ? 3 : 1
  }

  get chickenWidth() {
    return this.isTablet ? 6 : this.isMobile ? 6 : 10
  }

  get chickenHeight() {
    return this.isTablet ? 6 : this.isMobile ? 6 : 10
  }

  get normalMinWidth() {
    return this.normalChickens > 10 ? 3 : 6
  }

  get normalTopValue() {
    return this.normalChickens > 20
      ? null
      : this.normalChickens > 10
      ? this.isTablet
        ? -1.5
        : this.isMobile
        ? -1.5
        : -2.5
      : this.isTablet
      ? -2.3
      : this.isMobile
      ? -2.3
      : -3
  }

  get normalLeftValue() {
    return this.normalChickens > 10
      ? this.isTablet
        ? -1
        : this.isMobile
        ? -1.2
        : -2.5
      : this.isTablet
      ? 0
      : this.isMobile
      ? 0
      : -1
  }

  get normalBottomValue() {
    return this.normalChickens > 20 ? -0.5 : null
  }

  get organicMinWidth() {
    return this.organicChickens > 10 ? 3 : 6
  }

  get organicTopValue() {
    return this.organicChickens > 20
      ? null
      : this.organicChickens > 10
      ? this.isTablet
        ? -1.5
        : this.isMobile
        ? -1.5
        : -2.5
      : this.isTablet
      ? -2.3
      : this.isMobile
      ? -2.3
      : -3
  }

  get organicLeftValue() {
    return this.organicChickens > 10
      ? this.isTablet
        ? -1
        : this.isMobile
        ? -1.2
        : -2.5
      : this.isTablet
      ? 0
      : this.isMobile
      ? 0
      : -1
  }

  get organicBottomValue() {
    return this.organicChickens > 20 ? -0.5 : null
  }
}
